import { Stack } from '@festina-life/ui/structure'

type Props = {
  unavailableReasons: string[]
}

export const PushUnavailabilityTooltip = ({ unavailableReasons }: Props) => (
  <Stack className="flex-col max-w-md">
    {unavailableReasons.map((reason) => (
      <span key={reason}>{reason}</span>
    ))}
  </Stack>
)
